/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Studio_1_DescInputs */

const en_mk_studio_1_desc = /** @type {(inputs: Mk_Studio_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Median verified durations across projects, times your rate and a buffer — not a guess.`)
};

const id_mk_studio_1_desc = /** @type {(inputs: Mk_Studio_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Median durasi terverifikasi lintas proyek, dikali tarifmu dan buffer — bukan tebakan.`)
};

/**
* | output |
* | --- |
* | "Median verified durations across projects, times your rate and a buffer — not a guess." |
*
* @param {Mk_Studio_1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_studio_1_desc = /** @type {((inputs?: Mk_Studio_1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Studio_1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_studio_1_desc(inputs)
	return en_mk_studio_1_desc(inputs)
});